import Scroll from '../Scroll/Scroll';

export default class Selection {

	constructor(selector, parent = document) {
		this.isSelection = true;

		if (parent.isSelection) {
			parent = parent.get(0);
		}

		if (typeof selector === 'string') {
			this.nodes = parent.querySelectorAll(selector);
		} else if (typeof selector === 'object' && !selector.length) {
			this.nodes = [selector];
		} else if (selector == document || selector == window) {
			this.nodes = [selector];
		} else {
			this.nodes = selector;
		}
	}

	on(evt, cb) {
		for (let node of this.nodes) {
			node.addEventListener(evt, cb);
		}
	}

	off(evt, cb) {
		for (let node of this.nodes) {
			node.removeEventListener(evt, cb);
		}
	}

	each(cb, selection = true) {
		for (let node of this.nodes) {
			if (selection) {
				node = new Selection(node);
			}

			cb.call(this, node);
		}
	}

	get(index) {
		if (this.nodes[index]) {
			return this.nodes[index];
		}

		return null;
	}

	addClass(classNames) {
		this._toggleClass('add', classNames);
	}

	removeClass(classNames) {
		this._toggleClass('remove', classNames);
	}

	_toggleClass(method, classNames) {
		classNames = classNames.split(' ');

		for (let node of this.nodes) {
			for (let className of classNames) {
				if (method == 'add') {
					node.classList.add(className);
				} else if (method == 'remove') {
					node.classList.remove(className);
				}
			}
		}
	}

	hasClass(classNames) {
		if (!this.nodes.length) {
			return false;
		}

		let contains = true;
		classNames   = classNames.split(' ');

		for (let className of classNames) {
			if (!this.nodes[0].classList.contains(className)) {
				contains = false;
			}
		}

		return contains;
	}

	parent(classSelector = null) {
		if (!this.get(0)) {
			return null;
		}

		let parent = this.get(0).parentElement;

		if (classSelector) {
			const className = classSelector.replace('.', '');
			while (!parent.classList.contains(className) && parent != document.body) {
				parent = parent.parentElement;
			}
		}

		parent = new Selection(parent);
		return parent;
	}

	closest(classSelector) {
		const classNames = classSelector.replace('.', '');

		if (this.hasClass(classNames)) {
			return this;
		}

		return this.parent(classSelector);
	}

	width() {
		if (!this.get(0)) {
			return null;
		}

		return this.get(0).offsetWidth;
	}

	height() {
		if (!this.get(0)) {
			return null;
		}

		return this.get(0).offsetHeight;
	}

	css(css) {
		for (let node of this.nodes) {
			for (let property in css) {
				node.style[property] = css[property];
			}
		}
	}

	hide(duration = 500) {
		for (let node of this.nodes) {
			node.style.transition = `all ${duration}ms ease`;
			node.style.height     = `${node.scrollHeight}px`;
			node.style.visibility = 'visible';
			node.style.opacity    = 1;

			setTimeout(() => {
				node.style.height     = 0;
				node.style.visibility = 'hidden';
				node.style.opacity    = 0;
				node.style.padding    = 0;
			}, 100);
		}
	}

	show(duration = 500) {
		for (let node of this.nodes) {
			node.style.transition = `all ${duration}ms ease`;
			node.style.height     = 0;
			node.style.visibility = 'hidden';
			node.style.opacity    = 0;

			setTimeout(() => {
				node.style.height     = `${node.scrollHeight}px`;
				node.style.visibility = 'visible';
				node.style.opacity    = 1;
				node.style.padding    = null;
			}, 100);

			setTimeout(() => {
				node.style.height = 'auto';
			}, duration + 100);
		}
	}

	isEmpty() {
		const empty = (this.nodes.length) ? false : true
		return empty;
	}

	trigger(eventName, detail = false) {
		for (let node of this.nodes) {
			if (detail === false) {
				if (window.Event) {
					node.dispatchEvent(new Event(eventName));
				} else {
					const event = window.document.createEvent('UIEvents');
					event.initUIEvent(eventName, true, false, window, 0);
					node.dispatchEvent(event);
				}
			} else {
				node.dispatchEvent(new CustomEvent(eventName, { detail: detail }));
			}
		}
	}

	scrollTo(duration = 500, offset = 0) {
		vb.scroll.to(this.get(0), duration, offset);
	}

	data(attribute = null) {
		if (!attribute || !this.get(0)) {
			return null;
		}

		const dataAttribute = this.get(0).dataset[attribute];
		return dataAttribute;
	}

	text(text) {
		for (let node of this.nodes) {
			node.textContent = text;
		}
	}

	html(html) {
		for (let node of this.nodes) {
			node.innerHTML = html;
		}
	}

	outerHTML(html) {
		for (let node of this.nodes) {
			node.outerHTML = html;
		}
	}

	value() {
		if (!this.get(0)) {
			return null;
		}

		return this.get(0).value;
	}

	append(children) {
		const el = this.get(0);

		if (!el) {
			return false;
		}

		if (!children.isSelection) {
			children = new Selection(children);
		}

		for (let child of children.nodes) {
			el.appendChild(child);
		}
	}

}
